import { toSnakeCase } from "../handlers/urlHandler";

const projectName = toSnakeCase(process.env.NEXT_PUBLIC_PROJECT_NAME ?? '');

export const AUTH_DEVICE_TOKEN = projectName + '_auth_device_token';
export const AUTH_IDENTITY_TOKEN = projectName + '_auth_identity_token';
export const STORAGE_KEY_SHOPPING_CART = projectName + '_shopping_cart';
export const STORAGE_KEY_NEWSLETTER = projectName + '_newsletter';
export const STORAGE_KEY_VIEWED_PRODUCTS = projectName + '_viewed_products';
export const STORAGE_COOKIES_CONSENT = projectName + '_cookies_consent';

export const STORAGE_KEY_CART = projectName + '_cart';

export const STORAGE_KEY_CURRENT_CART = projectName + '_current_cart';

export const STORAGE_KEY_UTM_PARAMS = projectName + '_utm_params';

export const STORAGE_KEY_DEVICE_PLATFORM = projectName + '_device_platform';